<div class="page-container">
  <div class="menu-container">
    <div class="button-container" (click)="openSidebar()">
      <i class="pi pi-bars icon"></i>
    </div>
    <div class="page-label-container">
      {{ pageTitle }}
    </div>
    <div class="notification-container">
      @if (globalService.activePlanUnsaved() || globalService.standbyPlanUnsaved()) {
      <div class="unsaved">
        <i class="pi pi-save"></i>
        @if (!globalService.offline()) { Unsaved changes }
      </div>
      } @if (globalService.offline()) {
      <div class="offline">
        <i class="pi pi-wifi"></i>
        Offline
      </div>
      }
    </div>
  </div>
  <app-sidebar [(visible)]="sidebarVisible" />
  <div class="content" [style.height]="getContentHeight()">
    <ng-content></ng-content>
  </div>
</div>
